export const BusinessColorTypes = {
  BLACK: 1,
  WHITE: 2,
}

export function themeFromColorType(colorType) {
  return Number(colorType) === BusinessColorTypes.WHITE ? 'light' : 'dark'
}
